export default __webpack_public_path__ + "0bf631178cb1970f85a7ea3ddd3d8981.png";